import { createContext, useState } from "react";
import { toast } from "react-hot-toast";
import clienteAxios from "../config/clienteAxios";

const AuditContext = createContext();
const BASE_AUDIT_API_ROUTE = '/audit';

const AuditProvider = ({ children }) => {
  const [audit, setAudit] = useState(null);
  
  const getAllAudits = async () => {
    try {
      const { data } = await clienteAxios.get(BASE_AUDIT_API_ROUTE);
      setAudit(data.allAudit);
    } catch (error) {
      console.log(error);
    }
  };

  const createAuditRequest = async (values, deleteAudit) => {
    try {
      if (deleteAudit === "DELETE") {
        await clienteAxios.delete(BASE_AUDIT_API_ROUTE, {
          params: values,
        });
        toast.success("Se eliminó la publicación con éxito");
      } else if (deleteAudit === "EDIT") {
        await clienteAxios.put(
          BASE_AUDIT_API_ROUTE, 
          values,
          { params: { _id: values._id }},
        );
        toast.success("Se actualizó la publicación con éxito");
      } else {
        await clienteAxios.post(BASE_AUDIT_API_ROUTE, values);
        toast.success("Se creó la publicación con éxito");
      }
      await getAllAudits();
    } catch (error) {
      toast.error("Error al crear una nueva publicación");
    }
  };

  const handleApprovedRequest = async (id) => {
    try {
      await clienteAxios.post(`${BASE_AUDIT_API_ROUTE}/approveAudit`, {
        _id: id,
      });
      await getAllAudits();
      toast.success("Se aceptó la publicación");
    } catch (error) {
      toast.error("error");
    }
  };

  const deleteAudit = async (id) => {
    try {
      await clienteAxios.delete(`${BASE_AUDIT_API_ROUTE}/deleteAudit`, { params: { _id: id } });
      await getAllAudits();
      toast.error("Se eliminó la publicación");
    } catch (error) {
      toast.error("error");
    }
  };

  return (
    <AuditContext.Provider
      value={{
        audit,
        deleteAudit,
        handleApprovedRequest,
        createAuditRequest,
        getAllAudits,
      }}
    >
      {children}
    </AuditContext.Provider>
  );
};

export { AuditProvider };

export default AuditContext;
